import { createSlice } from '@reduxjs/toolkit'
import { setCurrentFilterInfo, setInitialFilterInfo } from '../../../actions'

/* NUM_OF_STOPS */
export const stopsFilter = createSlice({
  name: 'stopsFilter',
  initialState: [],
  reducers: {
    updateStopsFiltersUI: (state, action) => {
      const { payload = {}, meta = {} } = action.payload
      const stopKey = Object.keys(payload)[0]
      const { isNoneClick, isAllClick } = meta
      return state.map((stop) => {
        stop = { ...stop }
        if (meta.isOnlyClick) {
          stop.checked = stop.value === stopKey
        } else if (isNoneClick && !stop.disabled) {
          stop.checked = false
        } else if (isAllClick && !stop.disabled) {
          stop.checked = true
        } else {
          // stop.value and stopKey should both be strings
          stop.checked = payload.hasOwnProperty(stop.value) ? payload[stop.value] : stop.checked
        }

        return stop
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setInitialFilterInfo, (state, action) => {
      const { payload = {} } = action.payload
      return payload?.NUM_OF_STOPS || { ...state }
    })
    builder.addCase(setCurrentFilterInfo, (state, action) => {
      const { payload = {} } = action
      return payload?.stopsFilter
    })
  },
})

export const { updateStopsFiltersUI } = stopsFilter.actions
